import React, {FC, useState} from 'react';
import {
    GxForm,
    GxTextarea,
    GxButton,
    GxSpinner
} from '@garpix/garpix-web-components-react';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import ModalLayout from '../../../../components/ModalLayout';
import {IModalInvoice} from './interfaces';

import styles from './styles/index.module.scss';

export const ModalCommentChange: FC<IModalInvoice> = ({props, flag, onRequestClose}) => {
    const {comment, onChangeComment } = props;
    const [statusLoad, setStatusLoad] = useState(false);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            comment: comment || ''
        },
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: async ({comment}) => {
            setStatusLoad(true);
            try {
                onChangeComment(comment);
                toast.success('Комментарий успешно изменен!');
                onRequestClose();
            } catch (e) {
                toast.error('Ошибка сохранения комментария!');
            } finally {
                setStatusLoad(false);
            }
        }
    })

    return (
        <ModalLayout
            flag={flag}
            onClose={onRequestClose}
        >
            <div className={styles['header']}>
                <h2 className={styles['header--title']}>Редактировать комментарий</h2>
            </div>
            <GxForm onGx-submit={formik.submitForm}>
                <div className={styles['main']}>
                    <GxTextarea
                        resize='none'
                        label='Комментарий:'
                        value={formik.values.comment}
                        name='comment'
                        className={styles['comment']}
                        onGx-change={formik.handleChange}
                    />
                </div>
                <div className={styles['footer']}>
                    <div className={styles['footer--container']}>
                        <GxButton className={styles['btn--close']} onClick={onRequestClose}>Отмена</GxButton>
                        {statusLoad
                            ? <GxSpinner style={{fontSize: '2rem'}}/>
                            : <GxButton className={styles['btn--save']} type="submit">Сохранить</GxButton>
                        }
                    </div>
                </div>
            </GxForm>

        </ModalLayout>
    );
};
